export const requestKeyboardLock = () => {
  if (!navigator.keyboard) {
    return Promise.reject("No keyboard API");
  }
  return navigator.keyboard.lock();
};

export const getLayoutMap = async () => {
  if (!navigator.keyboard || !navigator.keyboard.getLayoutMap) {
    return Promise.reject("No getLayoutMap API");
  }
  const keyboardLayoutMap = await navigator.keyboard.getLayoutMap();
  if (keyboardLayoutMap.get("KeyQ") == "a") return "azerty";
  else if (keyboardLayoutMap.get("KeyQ") == "q") {
    if (keyboardLayoutMap.get("KeyY") == "z") return "qwertz";
    else if (keyboardLayoutMap.get("KeyY") == "y") return "qwerty";
  }
  return Promise.resolve(undefined);
};
